import React from 'react';
import PropTypes from 'prop-types';
import Translation from '../translation/translation';

export const Content = props => (
    <article className="free-mobile-fitting-light-box">

        <header className="free-mobile-fitting-light-box__header">
            <Translation
                tagName="h1"
                className="free-mobile-fitting-light-box__headline"
                translationKey={!props.showFreeShipping ? "catalog-delivery-info-lightbox-headline" : "navigation-level-2-deals-free-shipping-icon-alt"}
            />

            <div className="free-mobile-fitting-light-box__sub-header">
                <Translation
                    tagName="p"
                    translationKey={!props.showFreeShipping ? "catalog-delivery-info-lightbox-first-desc" : ""}
                />

                <Translation
                    tagName="p"
                    translationKey={!props.showFreeShipping ? "catalog-delivery-info-lightbox-last-desc" : "catalog-free-shipping-info-lightbox-desc"}
                />
            </div>
        </header>
        <footer className="free-mobile-fitting-light-box__footer">
            {!props.showFreeShipping &&
                <Translation
                    tagName="h2"
                    className="free-mobile-fitting-light-box__text-headline"
                    translationKey="catalog-delivery-info-lightbox-how-it-works"
                />
            }

            <Translation
                tagName="button"
                className="free-mobile-fitting-light-box__primary-cta"
                onClick={props.onClose}
                translationKey="catalog-delivery-info-lightbox-button"
            />
        </footer>
    </article>
);

Content.propTypes = {
    staticUrl: PropTypes.string.isRequired,
    baseUrl: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
};
